var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3208 14.3033C12.6171 16.007 9.00407 17.4801 6.07172 15.6679C5.90853 15.5671 5.82694 15.5167 5.76524 15.4922C5.64728 15.4455 5.55783 15.432 5.43133 15.4418C5.36517 15.4469 5.29021 15.4663 5.1403 15.5052C4.19695 15.7497 3.72528 15.8719 3.38547 15.8028C2.79569 15.6827 2.33477 15.2218 2.21474 14.632C2.14558 14.2922 2.26784 13.8206 2.51234 12.8772C2.55121 12.7273 2.57064 12.6523 2.57573 12.5859C2.58544 12.4594 2.57165 12.3689 2.52471 12.251C2.50008 12.1892 2.44973 12.1082 2.34902 11.9461C0.530667 9.02017 1.93792 5.47299 3.71421 3.6967C6.64314 0.767767 11.3919 0.767767 14.3208 3.6967C17.2497 6.62563 17.2497 11.3744 14.3208 14.3033Z",
    stroke: "#919DA9",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.78955 8.89331C6.78955 9.30752 6.45376 9.64331 6.03955 9.64331C5.62534 9.64331 5.28955 9.30752 5.28955 8.89331C5.28955 8.4791 5.62534 8.14331 6.03955 8.14331C6.45376 8.14331 6.78955 8.4791 6.78955 8.89331Z",
    fill: "#919DA9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.78955 8.89331C9.78955 9.30752 9.45376 9.64331 9.03955 9.64331C8.62534 9.64331 8.28955 9.30752 8.28955 8.89331C8.28955 8.4791 8.62534 8.14331 9.03955 8.14331C9.45376 8.14331 9.78955 8.4791 9.78955 8.89331Z",
    fill: "#919DA9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7896 8.89331C12.7896 9.30752 12.4538 9.64331 12.0396 9.64331C11.6253 9.64331 11.2896 9.30752 11.2896 8.89331C11.2896 8.4791 11.6253 8.14331 12.0396 8.14331C12.4538 8.14331 12.7896 8.4791 12.7896 8.89331Z",
    fill: "#919DA9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.e7716dd817b4dbb1cd8a9ce8b61e02e3.svg";
export { ForwardRef as ReactComponent };